import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {  EntityImageModal } from '../Entity';
import { TimeFormattingService, ContentService } from "../../services";

const CalibrationSection = connect((state) => ({ me: state.user.me }))(({ me, imageSrc, calibrationDate, timezone, inSidebar }) => {
    const [showImageModal, setShowImageModal] = useState(false);
    const [resolvedImageSrc, setResolvedImageSrc] = useState("");

    const calibrationValidForDays = me?.enterprise?.enterprisePreferences.filter((ep) => ep.token == "CALIBRATION_CERTIFICATE_EXPIRATION_DAYS");
    const expirationDate = calibrationValidForDays.length > 0 ? calibrationDate + calibrationValidForDays[0].numericValue * 24 * 60 * 60 * 1000 : null;
    const expiresAtTime = calibrationDate && expirationDate ? (expirationDate <= 0 ? "EXPIRED" : TimeFormattingService.renderFromNowTime(expirationDate, timezone)) : null;

    useEffect(() => {
        ContentService.getEntityImage(imageSrc)
            .then(setResolvedImageSrc)
            .catch((err) => {
                console.log(err);
            });
    }, [imageSrc]);

    return !inSidebar ?
        <div className="col-sm-8 col-md-6">
            <div className="card-data-cell remove-border-left">
                <label>Calibration</label>
                <p>
                    <a href="javascript:void(0)" onClick={() => setShowImageModal(true)}>
                        Certificate
                    </a>&nbsp;
                    {expiresAtTime ? `expires ${expiresAtTime}` : ""}
                </p>
                <EntityImageModal
                    title={`Calibration Certificate`}
                    subTitle={expiresAtTime ? `expires ${expiresAtTime}` : ""}
                    show={showImageModal}
                    onHide={() => {
                        setShowImageModal(false);
                    }}
                    imageSrc={resolvedImageSrc}
                />
            </div>
        </div>
        :
        <div>
            <label>Calibration</label>
            <p style={{ marginBottom: "30px" }}>
                <a href="javascript:void(0)" onClick={() => setShowImageModal(true)}>
                    Certificate
                </a>&nbsp;
                {expiresAtTime ? `expires ${expiresAtTime}` : ""}

                <EntityImageModal
                    title={`Calibration Certificate`}
                    subTitle={expiresAtTime ? `expires ${expiresAtTime}` : ""}
                    show={showImageModal}
                    onHide={() => {
                        setShowImageModal(false);
                    }}
                    imageSrc={resolvedImageSrc}
                />
            </p>
        </div>;
});

export default CalibrationSection;